module.exports = __webpack_public_path__ + "media/icons/remove-c578e4ea0d5b4d7fbe3ef854b45b1301.svg";